<template>
  <div class="page flex-col">
    <div class="flex-col">
      <div class="flex-col">
        <div class="box_2 flex-col"></div>
        <div class="text-wrapper_1 flex-row">
          <span class="text_7" :style="{color: select === 1 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(1)">企业简介</span>
          <span class="text_8" :style="{color: select === 2 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(2)">发展历程</span>
          <span class="text_9" :style="{color: select === 3 ? 'rgba(22, 119, 255, 1)' : 'rgba(153, 153, 153, 1)'}" @click="handleChange(3)">企业文化</span>
        </div>
        <CompanyIntroduction v-if="select === 1" />
        <DevelopmentHistory v-else-if="select === 2" />
        <CorporateCulture v-else-if="select === 3" />
      </div>
    </div>
  </div>
</template>
<script>
import CompanyIntroduction from '@/views/about_us/components/CompanyIntroduction.vue'
import DevelopmentHistory from '@/views/about_us/components/DevelopmentHistory/index.vue'
import CorporateCulture from '@/views/about_us/components/CorporateCulture/index.vue'

export default {
  components: {
    CompanyIntroduction,
    DevelopmentHistory,
    CorporateCulture,
  },
  data() {
    return {
      select: 1,
      constants: {}
    };
  },
  mounted() {
    if (this.$route.query?.select) {
      this.select = Number(this.$route.query?.select)
    }
  },
  methods: {
    handleChange(value) {
      this.select = value;
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
